import axios from "axios";

let authToken = null;

export const setAuthToken = (token) => {
  authToken = token || null;
};

const buildApiBaseUrl = () => {
  const rawBaseUrl =
    process.env.REACT_APP_API_BASE_URL ||
    "https://api.ashirandamishdevelopers.com/api";
  const trimmedBaseUrl = rawBaseUrl.replace(/\/+$/, "");

  if (/\/api$/i.test(trimmedBaseUrl)) {
    return trimmedBaseUrl;
  }

  return `${trimmedBaseUrl}/api`;
};

const apiClient = axios.create({
  baseURL: buildApiBaseUrl(),
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

export default apiClient;
